import React, { Fragment, useState, useEffect } from 'react';
import { Button, Row, Col, Modal, ModalHeader, ModalBody, ModalFooter, Form, InputGroup,Input } from 'reactstrap';
import { useForm, Controller } from "react-hook-form";
import TooltipItem from '../../Common/ToolTip';
import CratioFileUploader from '../Common/CratioFileUploader';
import { confirmBox, getDeleteIcon, getOrganizationInfo, getSessionValue, handleErrorResponse, parseJSON, showToast, translateContent, uploadFileIntoS3 } from '../../Common/Appcommon';
import Loading from '../../Common/Loading';
import requestApiService from '../../services/requestApi.service';
import { getProviderKey } from '../Agents/ProviderDetails';
import Select from 'react-select';
import { providerUploadOptions, retellOptions } from './constants';

const AddFilesModal = (props) => {
    let { onAdd, isModelOpen, onAddFileSuccess ,knbData,isEdit, type, currentRowId,knbformData} = props;
    const { handleSubmit: handleActionFormSubmit, control, formState: { errors }, trigger,setError } = useForm();
    const [formData, setFormData] = useState({});
    const [showButtonLoading, setShowButtonLoading] = useState(false);
    const [retellValue,setRetellVal] = useState(retellOptions[1]);
    const [isDisabled,setIsDisabled] = useState(false);
    const [proName, setProName] = useState("");
    const [constFileSize, setFileSize] = useState("50");
    const MAX_FILE_SIZE = proName === 'vapi' ? 100 * 1024 * 1024 : 50 * 1024 * 1024;
    const [formErrors, setFormErrors] = useState({});
    useEffect(() => {
        const provider = getSessionValue("agent_provider_name");
        setProName(provider);
        setFileSize(provider === 'vapi' ? "100" : "50");
        if(isEdit){
            formData.base_name = knbData['name'];
            setIsDisabled(true);
        } else {
            if(Object.keys(knbData).length === 0 && provider !== 'vapi'){
                formData.base_name = getOrganizationInfo("Organization_Name")+"'s Knowledge base";
                setFormData(formData);
            }
        }
    }, [knbData]);
    useEffect(() => {
        if(type !== undefined && type !== null){
            let providerOptions = providerUploadOptions[getSessionValue("agent_provider_name")];
            for(let ko = 0; ko < providerOptions.length;ko++){
                let option = providerOptions[ko];
                if(option.value === type.value){
                    setRetellVal(option);
                    break;
                }
            }
        }
    }, [type]);
    const submitFilesDetails = async () => {
        let isNameEmpty = (data) => !data?.["base_name"]?.trim();
        if (isNameEmpty(formData)) {
            setError("base_name", {
                type: "manual",
                message: "Invalid Action name.",
            });
            return;
        }
        if(/* (type.value === "upload_files" || type === "") && */ (retellValue?.value === 'upload_files' && (formErrors['uploadFile'] === undefined || formErrors['uploadFile'] !== "" ))){
            if(formErrors['uploadFile'] === undefined){
                setFormErrors(prevErrors => ({
                    ...prevErrors,
                    uploadFile: "File is required."
                }));
            }
            return;
        }
        setShowButtonLoading(true);
        /*let fileResult = await uploadFile();
        if (fileResult['issuccess']) {*/
            formData['knbData'] = knbData;
            formData['retellValue'] = retellValue;
            let params = {
                "ENTITY": "AIPROCESSOR",
                "OPERATION": "SAVE_KNOWLEDGE_BASE",
                "formData": formData,
                "isEdit" : isEdit,
                "isProviderUpdate" : true,
                "file" : formData['knowledge-document'],
                "fileparamname": "knowledge-document"
            }
            if(isEdit){
                params['currentRowId'] = currentRowId;
            }
            /*if(fileResult['errormsg'] === ''){*/
                let formresponse = await requestApiService.processServerRequest(params, "WebV2");
                if (formresponse.issuccess) {
                    setShowButtonLoading(false);
                    let currentFromData = "";
                    if(!!knbformData && knbformData.length > 1){
                        currentFromData = knbData;
                    }
                    onAddFileSuccess(currentFromData);
                }else{
                    handleErrorResponse(formresponse.errormsg);
                }
            /*}else{
                handleErrorResponse(fileResult['errormsg'] !== '' ? fileResult['errormsg'] :'knowledge base not created');
            }*/
        /*}else{
            showToast(fileResult['errormsg'],'top-right', "error");
        }*/
        setShowButtonLoading(false);
    }

    const onInputChange = async (e) => {
        let name = e.target.name;
        let value = e.target.value;
        if(name === "base_name"){
            if (value.length > 40) {
                value = value.slice(0, 40);
            }
        }
        setFormData((prevData) => ({
            ...prevData,
            [name]: value
        }));
    }

    const handleFileUpload = async (e, name) => {
        //let { formInputData } = await uploadFileIntoS3(e, formData, name);
        let fileSize = e.target.files[0]['size'];
        if(fileSize >= MAX_FILE_SIZE){
            setFormErrors(prevErrors => ({
                ...prevErrors,
                uploadFile: "File size must be under " + constFileSize + "MB"
            }));
        } else {
            let fData = formData;
            fData[name] = e.target.files[0];
            fData["mediaType"] = e.target.files[0]['type'];
            fData["fileName"] = e.target.files[0]['name'];
            setFormData(fData);
            setFormErrors(prevErrors => ({
                ...prevErrors,
                uploadFile: ""
            }));
        }
        //await uploadFile(e);
    };

    const clearFile = (name) => {
        let fData = formData;
        fData[name] = "";
        fData["mediaType"] = "";
        fData["fileName"] = "";
        setFormData(fData);
        setFormErrors(prevErrors => ({
                ...prevErrors,
                uploadFile: "Upload file is must."
            }));
    }

    const uploadFile = async () => {
        let isFileUploaded = false;
        let proName = getSessionValue("agent_provider_name");
        let apikey = getProviderKey(proName);
        const file = formData['knowledge-document'];//e.target.files[0]; 
        let url = 'https://api.vapi.ai/file';
        if (!file && proName !== 'retell') {
            console.error('Error: No file selected.');
            return;
        }

        const fData = new FormData();
        if(proName !== 'retell'){
            fData.append('file', file);
        }
        let errorResponse = {errormsg: "", issuccess : true};
        let errMsg = [];
        if(proName === 'retell'){
            if(file !== undefined && file !== null && file['size'] !== undefined && file['size'] !== null && file['size'] <= 0){
                errorResponse['errormsg'] = 'File has no content';
                errorResponse['issuccess'] = isFileUploaded;
                return errorResponse;
            }
            url = 'https://api.retellai.com/create-knowledge-base';
            if(isEdit){
                let knbDetails = knbData['details'];
                knbDetails = parseJSON(knbDetails);
                let knbId = knbDetails["knowledge_base_id"];
                url = `https://api.retellai.com/add-knowledge-base-sources/${knbId}`;
            }
            fData.append("knowledge_base_name", formData['base_name']);
            if(retellValue.value !== undefined && retellValue.value !== null && retellValue.value !== ''){
                if(retellValue.value === 'add_web_pages'){
                    const tmpData = [formData.web_title !== undefined && formData.web_title !== null && formData.web_title !== '' ? formData.web_title : '']; 
                    fData.append("knowledge_base_urls", JSON.stringify(tmpData));  
                }else if(retellValue.value === 'upload_files'){
                    fData.append("knowledge_base_files", file);
                }else{
                    const textData = {}; 
                    textData['text'] = formData.text_content !== undefined && formData.text_content !== null && formData.text_content !== '' ? formData.text_content : '';
                    textData['title'] = formData.web_title !== undefined && formData.web_title !== null && formData.web_title !== '' ? formData.web_title : '';
                    fData.append("knowledge_base_texts", JSON.stringify([textData])); 
                }
            }
            fData.append("enable_auto_refresh", "true");            
        }    
        try {
            const response = await fetch(url, {
                method: 'POST',
                headers: {
                    'Authorization': 'Bearer ' + apikey
                    // Note: Do NOT set 'Content-Type' here; `fetch` will automatically set it to multipart/form-data with the correct boundary.
                },
                body: fData
            });
            const result = await response.json();
            let tmpFormData = formData;
            if(isEdit){
                result["knowledge_base_sources"] = null;
            }
            tmpFormData["files_result"] = result;
            setFormData(tmpFormData);
            if(result['status'] !== undefined && result['status'] !== null && result['status'] !== '' && result['status'] === 'error'){
                errorResponse['errormsg'] = result['message'];
                errorResponse['issuccess'] = isFileUploaded;
                return errorResponse;
            } else {
                errorResponse['errormsg'] = '';
                errorResponse['issuccess'] = true;
                return errorResponse;
            }
        } catch (error) {
            isFileUploaded = false;
            errorResponse['errormsg'] = error;
            errorResponse['issuccess'] = isFileUploaded;
            console.log("file upload error: ", error)
        }
        return errorResponse;
    };

    const handleChange = (e) => {
        setRetellVal(e);
        setFormData(prevState => ({
            ...prevState,
            "knowledge-document": "",
            "web_title":''
          }));
    }
    return (
        <Modal isOpen={isModelOpen}>
            <ModalHeader toggle={onAdd} className='pb-0'>{retellValue.header ? retellValue.header : "Add Knowledge Base"}</ModalHeader>
            <form id="knowledge-base" name={'file'} onSubmit={handleActionFormSubmit((data, event) => submitFilesDetails(event))}>
                <ModalBody className='pt-1'>
                    <div className='agency-details p-0 g-1'>
                        <Row className={`${(type === '' || proName === 'vapi') ? '' : 'hide'}`}>
                            <Col md={12} className='field-section'>
                                <label className={'form-label'} htmlFor="base_name">Knowledge Base Name</label>
                                <Controller
                                    name="base_name"
                                    control={control}
                                    rules={{ required: !formData.base_name ? "Please provide Name" : ""}}
                                    render={({ field }) => {
                                        return (
                                            <input
                                                {...field}
                                                type="text"
                                                name="base_name"
                                                id="base_name"
                                                value={formData.base_name}
                                                autoComplete={"off"}
                                                onChange={(e) => {
                                                    onInputChange(e);
                                                    field.onChange(e);
                                                }}
                                                className={`form-control mt-2 ${errors.base_name ? 'is-invalid' : ''}`}
                                                
                                            />
                                        );
                                    }}
                                />
                                {errors.base_name && <em className={`error invalid-feedback`}>{errors.base_name.message}</em>}
                            </Col>
                        </Row>
                        <Row className={getSessionValue("agent_provider_name") === "retell" && type === "" ? '' : 'hide'}>
                            <Col md={12} className='field-section'>
                                <label className={'form-label'} htmlFor="base_name">Choose Type</label>
                                <Select 
                                    value={retellValue}
                                    options={retellOptions}
                                    className="basic-select mb-2 mt-2"
                                    classNamePrefix="sub-select wa-select"
                                    onChange={handleChange}
                                />
                            </Col>
                        </Row>
                        <Row className={getSessionValue('agent_provider_name') === 'retell' && retellValue.value !== 'upload_files' ? 'hide' : ''}>
                            <Col md={12} className='field-section mt-2'>
                                <InputGroup className='mb-2'>
                                    <label className={'form-label'} htmlFor="brand_logo">Upload File</label>
                                    <div className='pl-2 pt-1 hide'>
                                        <TooltipItem id={"1"} text={"Allowed file types: .pdf, .doc, .docx, .txt"} content={<i class="fi fi-ss-info"></i>} />
                                    </div>
                                </InputGroup>
                                <CratioFileUploader
                                    name="knowledge-document"
                                    comWidth={120}
                                    comHeight={24}
                                    fileName={formData['fileName']}
                                    errors={{}}
                                    handleFile={handleFileUpload}
                                    clearFile={clearFile}
                                    filesAccept={".pdf,.doc,.docx,.txt"}
                                    isAdmin={true}
                                    isDocument={true}
                                />
                                {/* <span className='field-desc'>Maximum File Size: 100 MB</span><br/> */}
                                {formErrors['uploadFile'] === undefined || formErrors['uploadFile'] !== "" && 
                                    <em class="error invalid-feedback">{formErrors['uploadFile']}</em>
                                }
                                <div>
                                    <span className='field-desc'>Supported File Types: .doc, .docx, .txt, .pdf | Max File Size: {constFileSize} MB</span>
                                </div>
                            </Col>
                        </Row>
                        <Row className={getSessionValue('agent_provider_name') === 'retell' && retellValue.value !== 'upload_files' ? '' : 'hide'}>
                            <Col md={12} className='field-section mt-2'>
                                <label className={'form-label'} htmlFor="base_name">{retellValue.value === 'add_web_pages' ? 'Page URL' : 'Title'}</label>
                                    <Controller
                                        name="web_title"
                                        control={control}
                                        rules={{ 
                                            required: (retellValue.value !== 'upload_files' && (formData.web_title === undefined || formData.web_title === null || formData.web_title === '')) ? `${retellValue.value === 'add_web_pages' ? 'Page URL is required.' : ' Title is required.'}` : "",
                                            validate: (value) => {if (retellValue.value === 'add_web_pages') {
                                                const pattern = /^(https?:\/\/)(www\.)?([a-zA-Z0-9-]+\.)*([a-zA-Z0-9-]+)(:\d+)?(\/[^\s]*)?$/;
                                                if (!pattern.test(value.trim())) {return "Enter a valid URL starting with http:// or https://";}}
                                                return true;
                                            }
                                        }}
                                        render={({ field }) => {
                                            return (
                                                <input
                                                    {...field}
                                                    type="text"
                                                    name="web_title"
                                                    id="web_title"
                                                    placeholder={retellValue.value === 'add_web_pages' ? 'Enter The Full URL Ex: https://example.com' : 'Enter title'}
                                                    value={formData.web_title}
                                                    autoComplete={"off"}
                                                    onChange={(e) => {
                                                        onInputChange(e);
                                                        field.onChange(e);
                                                    }}
                                                    className={`form-control mt-2 ${errors.web_title ? 'is-invalid' : ''}`}
                                                />
                                            );
                                        }}
                                    />
                                {errors.web_title && <em className={`error invalid-feedback`}>{errors.web_title.message}</em>}
                            </Col>
                            <Col md={12} className={`${retellValue.value === 'add_text' ? `field-section mt-2` : 'hide'}`}>
                                <label className={'form-label'} htmlFor="base_name">Text Content</label>
                                    <Controller
                                        name="text_content"
                                        control={control}
                                        rules={{ required: (retellValue.value === 'add_text' && (formData.text_content === undefined || formData.text_content === null || formData.text_content.trim() === "")) ? "Text Content is required.." : "",validate: (value) => {
                                            if(formData.text_content && formData.text_content.trim() === "") {
                                            return translateContent("vm.action.error.msg",{content: "Text Content"});
                                         }} }}
                                        render={({ field }) => {
                                            return (
                                                <Input
                                                    {...field}
                                                    type="textarea"
                                                    name="text_content"
                                                    id="text_content"
                                                    placeholder={retellValue.value === 'add_web_pages' ? '' : 'Enter content'}
                                                    value={formData.text_content}
                                                    autoComplete={"off"}
                                                    onChange={(e) => {
                                                        onInputChange(e);
                                                        field.onChange(e);
                                                    }}
                                                    className={`form-control form-control-height mt-2${errors.text_content ? 'is-invalid' : ''}`}
                                                />
                                            );
                                        }}
                                    />
                                {errors.text_content && <em className={`error invalid-feedback`}>{errors.text_content.message}</em>}
                            </Col>
                        </Row>
                    </div>
                </ModalBody>
                <ModalFooter>
                    <Loading showLoader={showButtonLoading} mainContent={
                        <Fragment>
                            <Button className='d-flex flex-center align-center theme-bg-g'>
                                Save
                            </Button>
                        </Fragment>
                    } />
                </ModalFooter>
            </form>
        </Modal>
    );
}

export default AddFilesModal;